// Bump these strings when the legal documents materially change.
// All users will be re-prompted to accept the new version.
export const CURRENT_TERMS_VERSION = "2026-05-31";
export const CURRENT_PRIVACY_VERSION = "2026-05-31";

export function needsLegalReconsent(profile: {
  terms_version?: string | null;
  privacy_version?: string | null;
} | null | undefined): boolean {
  if (!profile) return false;
  return (
    profile.terms_version !== CURRENT_TERMS_VERSION ||
    profile.privacy_version !== CURRENT_PRIVACY_VERSION
  );
}